import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=300b3cb2&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b3cb2",
  null
  
)

export default component.exports